export var updateListItemAndScrollItem = (_ref, _filterList, listRef, type, shouldAllowToggle) => {
  var item = _ref.item,
    index = _ref.index;
  var _a;
  var filterList = deepClone(_filterList);
  filterList[index].isSelected = !filterList[index].isSelected;
  (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
    animated: true,
    index
  });
  if (type === 'single') {
    filterList.map((_item, _index) => {
      if (_index !== index) _item.isSelected = false;
      if (!shouldAllowToggle && _index === index) _item.isSelected = true;
      return item;
    });
  }
  return filterList;
};
export var initiallySingleSelectFromList = (type, _filterList, listRef, setFilterList) => {
  if (type === 'single') {
    var filterList = deepClone(_filterList);
    var index = filterList === null || filterList === void 0 ? void 0 : filterList.findIndex(item => item.isSelected);
    if (index >= 0) {
      filterList[index].isSelected = false;
      var updatedList = updateListItemAndScrollItem({
        item: filterList[index],
        index
      }, filterList, listRef, type);
      setFilterList([...updatedList]);
    }
  }
};
var deepClone = data => {
  return JSON.parse(JSON.stringify(data));
};